import { render, staticRenderFns } from "./CountryUpdate.vue?vue&type=template&id=0b86a2ec&"
import script from "./CountryUpdate.vue?vue&type=script&lang=js&"
export * from "./CountryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports